import { Providers } from './providers';
import { AppRouter } from './router';
import { AuthGate } from '@/features/auth/AuthGate';
import { Toast } from '@/components/ui/Toast';

export default function App() {
  return (
    <Providers>
      <AuthGate>
        <AppRouter />
        <Toast />
      </AuthGate>
    </Providers>
  );
}
